import type { ComponentType } from "react";
import { PostArticle, PostIndex } from "../components/Blog.tsx";
import ContactForm from "../components/ContactForm.tsx";
import { ResumePage } from "../components/Resume.tsx";
import {
  About,
  BlogPreview,
  Hero,
  Projects,
  Skills,
  TextSection,
} from "../components/Sections.tsx";
import TorqueCalculator from "../components/TorqueCalculator.tsx";
import type { CMSNode } from "../types.ts";

type Renderer = ComponentType<{ node: CMSNode }>;

/**
 * componentType -> renderer. `null` marks config-only nodes that their parent
 * reads directly. Unregistered types fall back to UnknownComponent.
 * Block slugs in shams-cms-admin must match these names.
 */
export const registry: Record<string, Renderer | null> = {
  // page blocks (Payload "layout" blocks)
  Hero,
  About,
  Skills,
  Projects,
  BlogPreview,
  ContactForm,
  TextSection,
  TorqueCalculator,

  // blog routes, built by server/pages.ts
  PostIndex,
  PostArticle,

  // /cv, built by server/pages.ts
  ResumePage,
};
